/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreatePlanResourceRequest
 */
export interface CreatePlanResourceRequest {
    /**
     * 
     * @type {string}
     * @memberof CreatePlanResourceRequest
     */
    effectTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanResourceRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanResourceRequest
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePlanResourceRequest
     */
    role?: string;
    /**
     * 
     * @type {number}
     * @memberof CreatePlanResourceRequest
     */
    notionalCapacityHoursPerWeek?: number;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePlanResourceRequest
     */
    active?: boolean;
}

/**
 * Check if a given object implements the CreatePlanResourceRequest interface.
 */
export function instanceOfCreatePlanResourceRequest(value: object): value is CreatePlanResourceRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreatePlanResourceRequestFromJSON(json: any): CreatePlanResourceRequest {
    return CreatePlanResourceRequestFromJSONTyped(json, false);
}

export function CreatePlanResourceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlanResourceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
        'name': json['name'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'role': json['role'] == null ? undefined : json['role'],
        'notionalCapacityHoursPerWeek': json['notionalCapacityHoursPerWeek'] == null ? undefined : json['notionalCapacityHoursPerWeek'],
        'active': json['active'] == null ? undefined : json['active'],
    };
}

export function CreatePlanResourceRequestToJSON(json: any): CreatePlanResourceRequest {
    return CreatePlanResourceRequestToJSONTyped(json, false);
}

export function CreatePlanResourceRequestToJSONTyped(value?: CreatePlanResourceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'effectTenantId': value['effectTenantId'],
        'name': value['name'],
        'userId': value['userId'],
        'role': value['role'],
        'notionalCapacityHoursPerWeek': value['notionalCapacityHoursPerWeek'],
        'active': value['active'],
    };
}

